import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import PageAnimations from "webPage/PageAnimations";
import "jquery-serializejson";
import "settings";
import Page from "webPage/Page";
import Track from "util/Track";
import {handleStickyNav, updateStickyNav} from "util/handleStickyNav";
import handleAnalyticsClicks from "util/handleAnalyticsClicks";

let $header_page_overlay = $('.js-header-page-overlay');

window.$ = jQuery;

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);

    Page.init();
    PageAnimations.start();
    handleStickyNav();
    handleAnalyticsClicks();

    $('body').on('click', '.js-accordion-btn', function () {
        let $accordionWrap = $(this).closest($(".js-accordion-wrap"));
        $accordionWrap.toggleClass("footer-list--active");
        $accordionWrap.find('.footer-list__body').slideToggle();

    }).on('click', '.js-toggle-nav, .header-top-nav__overlay', function () {
        $('body').toggleClass('show-navigation');
        return false;

    }).on('click', '.js-nav-open-dropdown', function () {
        if ($(window).outerWidth() < 1200) {
            $('.js-header').css("transform", "");
            $('.header-bot-nav__item--dropdown').removeClass('header-bot-nav__item--nav-active');
            $('body').addClass('nav-dropdown-active');
            $header_page_overlay.addClass('header__page-overlay--active');
            $(".nav-dropdown").removeClass("nav-dropdown--active");
            $(this).parent('.header-bot-nav__item--dropdown').addClass('header-bot-nav__item--nav-active');
            $(this).siblings($(".js-nav-dropdown")).addClass("nav-dropdown--active");
            return false;
        }

    }).on('click', '.js-nav-close-dropdown, .js-header-page-overlay', function () {
        $('body').removeClass('nav-dropdown-active');
        $('.header-bot-nav__item--dropdown').removeClass('header-bot-nav__item--nav-active');
        $header_page_overlay.removeClass('header__page-overlay--active');
        $('.nav-dropdown--active').removeClass("nav-dropdown--active");
        updateStickyNav();

    }).on('mouseover', '.header-bot-nav__item--dropdown, .js-nav-dropdown', function () {
        if ($(window).outerWidth() >= 1200) {
            $header_page_overlay.removeClass('header__page-overlay--out-active');
            $header_page_overlay.addClass('header__page-overlay--active');
        }

    }).on('mouseout', '.header-bot-nav__item--dropdown, .js-nav-dropdown', function () {
        if ($(window).outerWidth() >= 1200) {
            $header_page_overlay.removeClass('header__page-overlay--active');
            $header_page_overlay.addClass('header__page-overlay--out-active');
        }
    });

    $(window).on("resize", function () {
        if ($(window).outerWidth() >= 1199) {
            $('body').removeClass('nav-dropdown-active');
            $(".nav-dropdown").removeClass("nav-dropdown--active");
            $header_page_overlay.removeClass('header__page-overlay--active');
            $header_page_overlay.removeClass('header__page-overlay--out-active');
        }
    });

    let $imageTrack = $(".js-image-track-wrap");

    if ($imageTrack.length > 0) {
        new Track($imageTrack, {
            classes: {
                block: "slider",
            },
        });
    }

    new Track($('.js-rating-track-wrap'), {
        classes: {
            block: "rating-slider",
        },
    });
});

export function svg_include(icon, suffix = '') {
    let url = '';

    if ('undefined' !== typeof window.CONFIG.svgIconsVersion && window.CONFIG.svgIconsVersion === 2) {
        url = window.CONFIG.themeUri + '/images/svg-icons/' + icon + '.svg';

        if ('undefined' !== typeof window.CONFIG.svgHashes[icon]) {
            url += '?hash=' + window.CONFIG.svgHashes[icon];
        }

        url += '#content';
    } else {
        url = window.CONFIG.themeUri + '/includes/svg-icons.svg#' + icon;
    }

    return '<svg><use xlink:href="' + url + '"></use></svg>';
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
